import React from 'react';
import { Loader2 } from 'lucide-react';

export const Panel = ({ title, subtitle, action, children, testId }) => (
  <div className="p-6 max-w-[1500px]" data-testid={testId}>
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="text-2xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="text-zinc-500 text-sm mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const PanelLoader = () => (
  <div className="flex items-center justify-center py-20"><Loader2 className="animate-spin text-[#b8ff00]" size={24} /></div>
);

export const EmptyState = ({ icon: Icon, text, cta }) => (
  <div className="text-center py-14 bg-zinc-900 border border-zinc-800 border-dashed rounded-xl">
    {Icon && <Icon size={30} className="mx-auto mb-3 text-zinc-600" />}
    <p className="text-zinc-500 text-sm">{text}</p>
    {cta && <div className="mt-4">{cta}</div>}
  </div>
);

export const Card = ({ children, className = '', ...rest }) => (
  <div className={`bg-zinc-900 border border-zinc-800 rounded-xl ${className}`} {...rest}>{children}</div>
);

export const Stat = ({ label, value, sub, tone = 'text-white' }) => (
  <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
    <p className="text-[11px] uppercase tracking-wider text-zinc-500">{label}</p>
    <p className={`text-2xl font-bold mt-1 ${tone}`}>{value}</p>
    {sub && <p className="text-[11px] text-zinc-500 mt-0.5">{sub}</p>}
  </div>
);

export const Field = ({ label, children, hint }) => (
  <div className="space-y-1.5">
    <label className="text-xs font-medium text-zinc-400">{label}</label>
    {children}
    {hint && <p className="text-[11px] text-zinc-600">{hint}</p>}
  </div>
);

export const Chip = ({ active, children, onClick, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`px-3 py-1.5 rounded-full text-xs font-medium capitalize transition-colors ${
      active ? 'bg-[#b8ff00] text-black' : 'bg-zinc-800 text-zinc-400 hover:text-white'
    }`}
  >{children}</button>
);

export const inputCls = 'bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-600';

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      return true;
    } catch {
      return false;
    }
  }
};
